// DualSlider.js
import React from "react";
import { Range, getTrackBackground } from "react-range";

const MIN = 0;
const MAX = 100;
const STEP = 1;

function DualSlider({ values, onChange }) {
  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Profit Split (%)
      </label>

      <Range
        values={values}
        step={STEP}
        min={MIN}
        max={MAX}
        onChange={onChange}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            className="h-2 w-full rounded bg-gray-200"
            style={{
              background: getTrackBackground({
                values,
                colors: ["#34d399", "#3b82f6", "#fbbf24"],
                min: MIN,
                max: MAX,
              }),
            }}
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            className="h-5 w-5 rounded-full bg-blue-600 border-2 border-white shadow"
          />
        )}
      />

      <div className="flex justify-between mt-2 text-sm text-gray-600">
        <span>0%</span>
        <span>100%</span>
      </div>
    </div>
  );
}

export default DualSlider;
